var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
export var createTrackingBundleUrl = function (trackingBundleBaseUrl, trackingBundleParameters) {
    var counterName = trackingBundleParameters.counterName, svcModuleName = trackingBundleParameters.svcModuleName, customCounterName = trackingBundleParameters.customCounterName, debug = trackingBundleParameters.debug, forceLoad = trackingBundleParameters.forceLoad, initialPageView = trackingBundleParameters.initialPageView, reportEventsIndividually = trackingBundleParameters.reportEventsIndividually, addOnClick = trackingBundleParameters.addOnClick;
    var trackingBundleUrlParameters = {
        'cP--countername': counterName,
        'cP--svc_module_name': svcModuleName,
        initialPageView: !!initialPageView,
        customCounterName: customCounterName,
        debug: debug,
        forceLoad: forceLoad,
        addOnClick: addOnClick ? '' : undefined,
        reportEventsIndividually: reportEventsIndividually ? '' : undefined,
    };
    var filteredParameters = Object.entries(trackingBundleUrlParameters).reduce(function (filteredParams, _a) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        if (value !== undefined && value !== null) {
            filteredParams[key] = value.toString();
        }
        return filteredParams;
    }, {});
    return "".concat(trackingBundleBaseUrl, "?").concat(new URLSearchParams(filteredParameters));
};
